<div *ngIf="!item.isActivity" (click)="onClick(item)" class="itb-list-items" [ngClass]="{'with-button':item.actionButtonClassName, 'simple-list':item.isSimple}" >
  <div class="left">
      <itb-icon *ngIf="item.iconClassName" [className]="item.iconClassName"></itb-icon>
      <itb-text *ngIf="!isLinkItem" [className]="item.textClassName" [text]="item.text"></itb-text>
      <a *ngIf="isLinkItem" routerLink="{{item.link}}"><itb-text [className]="item.textClassName" [text]="item.text"></itb-text></a>
  </div>
  <div class="right">    
      <div class="let-go" *ngIf="item.actionButtonClassName" (onClickHandler)="defaultButtonClick(item)" >Let's Go!</div>
      <itb-round-button *ngIf="item.roundButtonClassName" (onClickHandler)="roundButtonClick(item)" [className]="item.roundButtonClassName" [iconClassName]="item.roundButtonIconClassName"></itb-round-button>
  </div>
  <itb-text *ngIf="item.tagText" class="tagText" [className]="'text-small'" [text]="item.tagText"></itb-text>
</div>

<li class="itb-activity-list" *ngIf="item.isActivity">
  <span class="activity-icon">
    <itb-icon *ngIf="item.iconClassName" [className]="item.iconClassName"></itb-icon>
  </span>
  <span class="activity-text">
    <span class="asset-name"><b>SSLLabs</b></span>
    <b class="">google.com</b>
    <span class="act-up"><i>updated </i></span><span> by </span>
    <span class="act-user">Rukhsar Irshad</span><br>
    <span class="act-date">Nov 16, 2019 5:00:09 AM</span> - 
    <span class="act-text"><b class="ng-binding">1quicka2322323</b></span>
  </span>
</li>